import { loading, success, reset, handleErrorException } from 'State/actions';
import * as types from './types';

const resourceName = 'vending';
const humanName = 'Vending Machine';

export const getVendingMachines = () => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.VENDING_GETVENDINGMACHINES_LOADING, true));

      const response = await MPWWebApi.getGeneric(resourceName);

      dispatch(
        success(types.VENDING_GETVENDINGMACHINES_SUCCESS, response.data.Data)
      );
    } catch (error) {
      dispatch(
        handleErrorException(error, types.VENDING_GETVENDINGMACHINES_ERROR, {
          title: 'Error',
          Message: `Unable to get ${humanName}s`,
        })
      );
    } finally {
      dispatch(loading(types.VENDING_GETVENDINGMACHINES_LOADING, false));
    }
  };
};

export const postVendingMachine = data => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.VENDING_POSTVENDINGMACHINE_LOADING, true));

      const response = await MPWWebApi.postGenericInsertUpdate(
        resourceName,
        data
      );

      await dispatch(getVendingMachines());

      dispatch(
        success(types.VENDING_POSTVENDINGMACHINE_SUCCESS, response.data.Data)
      );
    } catch (error) {
      dispatch(
        handleErrorException(error, types.VENDING_POSTVENDINGMACHINE_ERROR, {
          title: 'Error',
          Message: `Unable to add or update ${humanName}`,
        })
      );
    } finally {
      dispatch(loading(types.VENDING_POSTVENDINGMACHINE_LOADING, false));
    }
  };
};

export const clearPostVendingMachineResult = () => {
  return dispatch => {
    dispatch(reset(types.VENDING_POSTVENDINGMACHINE_SUCCESS, null));
    dispatch(reset(types.VENDING_POSTVENDINGMACHINE_ERROR, null));
  };
};

export const postDeleteVendingMachine = id => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.VENDING_POSTDELETEVENDINGMACHINE_LOADING, true));

      const response = await MPWWebApi.postGenericDelete(resourceName, id);

      await dispatch(getVendingMachines());

      dispatch(
        success(
          types.VENDING_POSTDELETEVENDINGMACHINE_SUCCESS,
          response.data.Data
        )
      );
    } catch (error) {
      dispatch(
        handleErrorException(
          error,
          types.VENDING_POSTDELETEVENDINGMACHINE_ERROR,
          {
            title: 'Error',
            Message: `Unable to delete ${humanName}`,
          }
        )
      );
    } finally {
      dispatch(loading(types.VENDING_POSTDELETEVENDINGMACHINE_LOADING, false));
    }
  };
};

export const clearPostDeleteVendingMachineResult = () => {
  return dispatch => {
    dispatch(reset(types.VENDING_POSTDELETEVENDINGMACHINE_SUCCESS, null));
    dispatch(reset(types.VENDING_POSTDELETEVENDINGMACHINE_ERROR, null));
  };
};



// WEBPACK FOOTER //
// ./src/pages/vendingsetup/state/actions.js